<template>
  <div class="home-page-container">
    <div class="content-wrapper">
      <!-- Hero Section -->
      <div class="hero-section">
        <div class="text-content">
          <div class="greeting-message">
            <span class="hi-text">Hi</span>
            <v-icon
              icon="mdi-hand-wave"
              size="large"
              color="white"
              class="hand-icon"
            ></v-icon>
            <span class="name-text">I'm Aisha</span>
          </div>

          <h1 class="title">Frontend Developer & DevEx</h1>

          <p class="tagline">
            based in Sweden. I share authentic, real-world advice about working
            in tech based on my journey from frontend engineering to developer
            experience in corporate Sweden.
          </p>

          <div class="cta-buttons">
            <v-btn
              to="/blog"
              color="white"
              variant="elevated"
              size="large"
              class="primary-btn"
            >
              Read the latest Blog posts
            </v-btn>
            <v-btn
              to="/newsletter"
              variant="outlined"
              color="white"
              size="large"
              class="newsletter-btn"
            >
              Subscribe to the newsletter
            </v-btn>
          </div>

          <!-- Social Links
          <div class="social-links">
            <v-btn
              icon
              variant="text"
              color="white"
              href="https://linkedin.com/in/aisha-keita"
              target="_blank"
              size="large"
            >
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>
            <v-btn
              icon
              variant="text"
              color="white"
              href="https://github.com/AishaKEITA"
              target="_blank"
              size="large"
            >
              <v-icon>mdi-github</v-icon>
            </v-btn>
            <v-btn
              icon
              variant="text"
              color="white"
              href="https://www.instagram.com/aishastechroom/"
              target="_blank"
              size="large"
            >
              <v-icon>mdi-instagram</v-icon>
            </v-btn>
            <v-btn
              icon
              variant="text"
              color="white"
              href="https://www.youtube.com/@aishastechroom"
              target="_blank"
              size="large"
            >
              <v-icon>mdi-youtube</v-icon>
            </v-btn>
          </div> -->
        </div>

        <!-- Image Section -->
        <div class="landing-image">
          <img
            alt="Aisha's Tech Room - Technical Writer & Developer"
            src="../assets/aisha.png"
            class="profile-pic"
          />
          <div class="image-about-cta">
            <v-btn
              to="/about"
              color="white"
              variant="elevated"
              size="large"
              class="image-about-btn"
            >
              Hi! I am Aisha<v-icon end>mdi-hand-wave</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- <section class="podcast-spotlight">
        <div class="podcast-content">
          <div class="podcast-title-row">
            <v-icon color="#ffcc80" size="28">mdi-microphone</v-icon>
            <h2>Aisha's Tech Room Podcast</h2>
          </div>
          <p>
            Listen to the latest episodes on career growth, personal
            development, and life in corporate tech.
          </p>
          <div class="podcast-actions">
            <v-btn
              color="white"
              variant="elevated"
              href="https://pod.link/aHR0cHM6Ly9hbmNob3IuZm0vcy8xMGJiYTY2NzgvcG9kY2FzdC9yc3M"
              target="_blank"
              class="podcast-all-btn"
              prepend-icon="mdi-podcast"
            >
              Listen on all platforms
            </v-btn>
          </div>
        </div>
      </section> -->

      <section class="resources-spotlight">
        <div class="resources-content">
          <div class="resources-title-row">
            <v-icon color="#ffcc80" size="28">mdi-file-pdf-box</v-icon>
            <h2>Resources</h2>
          </div>
          <p>
            Access the free PDF guide: Free AI Resources for People Breaking
            Into Tech.
          </p>
          <div class="resources-actions">
            <v-btn
              to="/resources"
              color="white"
              variant="elevated"
              class="resources-open-btn"
              prepend-icon="mdi-open-in-new"
            >
              Open Resources
            </v-btn>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<style scoped>
.home-page-container {
  background: linear-gradient(135deg, #0097a7 0%, #00838f 100%);
  min-height: calc(100vh - 64px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
}

.content-wrapper {
  width: 100%;
  max-width: 1200px;
}

.hero-section {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-bottom: 2.25rem;
}

.text-content {
  color: white;
}

.greeting-message {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  animation: fadeInDown 0.8s ease;
}

.hand-icon {
  animation: wave 1s ease-in-out infinite;
}

@keyframes wave {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(20deg);
  }
  75% {
    transform: rotate(-20deg);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: white;
  animation: fadeInUp 1s ease;
}

.tagline {
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 2.5rem;
  color: rgba(255, 255, 255, 0.95);
  max-width: 600px;
  animation: fadeInUp 1.2s ease;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  animation: fadeInUp 1.4s ease;
}

.primary-btn {
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: buttonPulse 2.8s ease-in-out infinite;
}

.primary-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.secondary-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  border: 2px solid white;
}

.secondary-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
}

.newsletter-btn {
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.3px;
  border: 2px solid #ffcc80;
  color: #ffcc80 !important;
  background: rgba(0, 0, 0, 0.12);
  animation: buttonPulseAlt 3.2s ease-in-out infinite;
}

.newsletter-btn:hover {
  background-color: rgba(255, 204, 128, 0.18);
  transform: translateY(-3px);
}

.social-links {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.25rem;
  animation: fadeInUp 1.6s ease;
  flex-wrap: wrap;
}

.social-links .v-btn {
  transition: all 0.3s ease;
}

.social-links .v-btn:hover {
  transform: translateY(-5px) scale(1.1);
  background-color: rgba(255, 255, 255, 0.1);
}

.landing-image {
  animation: fadeIn 1.5s ease;
}

.profile-pic {
  width: 100%;
  max-width: 450px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 4px solid white;
  transition: transform 0.3s ease;
}

.profile-pic:hover {
  transform: scale(1.05);
}

.image-about-cta {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.image-about-btn {
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.35px;
  color: #007f8c;
  animation: buttonPulse 3.4s ease-in-out infinite;
}

@keyframes buttonPulse {
  0%,
  100% {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.22);
  }
  50% {
    box-shadow: 0 10px 24px rgba(255, 255, 255, 0.28);
  }
}

@keyframes buttonPulseAlt {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(255, 204, 128, 0.22);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 204, 128, 0.08);
  }
}

.podcast-spotlight {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  padding: 1.5rem 1.6rem;
  backdrop-filter: blur(8px);
  animation: fadeInUp 1.8s ease;
}

.podcast-content {
  max-width: 900px;
}

.podcast-title-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.5rem;
}

.podcast-title-row h2 {
  color: white;
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0;
}

.podcast-spotlight p {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1rem;
  line-height: 1.65;
  margin-bottom: 0.85rem;
}

.podcast-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.podcast-all-btn {
  text-transform: none;
  font-weight: 600;
}

.podcast-all-btn {
  color: #007f8c;
}

.resources-spotlight {
  margin-top: 1rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  padding: 1.5rem 1.6rem;
  backdrop-filter: blur(8px);
  animation: fadeInUp 2s ease;
}

.resources-content {
  max-width: 900px;
}

.resources-title-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.5rem;
}

.resources-title-row h2 {
  color: white;
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0;
}

.resources-spotlight p {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1rem;
  line-height: 1.65;
  margin-bottom: 0.85rem;
}

.resources-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.resources-open-btn {
  text-transform: none;
  font-weight: 700;
  color: #007f8c;
}

.stats-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  animation: fadeInUp 1.8s ease;
}

.stat-item {
  text-align: center;
  color: white;
}

.stat-item h3 {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.stat-item p {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
}

@media (max-width: 768px) {
  .hero-section {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .text-content {
    order: 2;
  }

  .landing-image {
    order: 1;
  }

  .greeting-message {
    font-size: 2rem;
    justify-content: center;
  }

  .title {
    font-size: 1.8rem;
  }

  .tagline {
    font-size: 1rem;
    margin-left: auto;
    margin-right: auto;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }

  .podcast-spotlight {
    padding: 1.35rem;
    text-align: center;
  }

  .podcast-title-row {
    justify-content: center;
  }

  .podcast-title-row h2 {
    font-size: 1.25rem;
  }

  .podcast-actions {
    justify-content: center;
  }

  .podcast-actions .v-btn {
    width: 100%;
    max-width: 320px;
  }

  .resources-actions {
    justify-content: center;
  }

  .resources-actions .v-btn {
    width: 100%;
    max-width: 320px;
  }

  .cta-buttons .v-btn {
    width: 100%;
    max-width: 300px;
  }

  .social-links {
    justify-content: center;
  }

  .social-links .v-btn {
    margin-bottom: 0.25rem;
  }

  .profile-pic {
    max-width: 300px;
  }
}
</style>
